import { render } from "./DomainConfirm.vue?vue&type=template&id=6869827f"
import script from "./DomainConfirm.vue?vue&type=script&lang=js"
export * from "./DomainConfirm.vue?vue&type=script&lang=js"

import "./DomainConfirm.vue?vue&type=style&index=0&id=6869827f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__